import _ from 'lodash';
import { weightToName } from '../constants/product';
import { defaultFlowerThresholds, integrationsByCategory } from '../constants/integrations';
export var getIntegrationCategory = function getIntegrationCategory(adapter) {
  var category = _.map(integrationsByCategory, function (value, key) {
    if (_.has(value, adapter)) {
      return key;
    }
  });
  return _.find(category, function (i) {
    return !!i;
  });
};
export var getIntegrationThreshold = function getIntegrationThreshold() {
  var thresholds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var category = arguments.length > 1 ? arguments[1] : undefined;
  var weight = arguments.length > 2 ? arguments[2] : undefined;
  var defaultZero = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  /*
   * data structure looks like:
   * thresholds = {
   *    category: string | { weight: string, ... }
   * }
   */
  var defaultThreshold = 5;
  // use flower specific defaults
  if (category === 'Flower') {
    defaultThreshold = defaultFlowerThresholds[weight] || 1;
  }

  // use 0 for kiosk defaults
  if (defaultZero) {
    defaultThreshold = 0;
  }

  // if we dont have thresholds, use defaults
  if (!thresholds || !thresholds[category]) {
    return defaultThreshold;
  }

  // this should never be flower. return the threshold value for a given category
  if (_.isString(thresholds[category])) {
    if (category === 'Flower') {
      return defaultThreshold;
    }
    return parseInt(thresholds[category], 10);
  }

  // this should always be flower. weight may need to be translated first. e.g. 3.5g -> 1/8oz
  var weightName = weight.replace('.', '[dot]');
  if (weightToName[weight]) {
    weightName = weightToName[weight];
  }
  return parseInt(thresholds[category][weightName] || defaultThreshold, 10);
};